<template>
  <dialogCommon
    ref="dialogCommon"
    :title="title"
    icon="icon-cy-idxDeail"
    class="detailDialog"
    width="1220px"
  >
    <div class="condition">
      <div class="condition_input">
        <el-select
          v-if="isShowInspectType"
          v-model="inspectType"
          @change="search"
          popper-class="dialog-select"
        >
          <el-option
            v-for="(item, index) in inspectTypeList"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
        <div class="search-input keyword">
          <el-input
            v-model="keyword"
            placeholder="请输入关键词查询"
            @keyup.enter.native="search"
          /><i
            v-if="isDirectSearch"
            class="icon yq-datatype-mulit"
          />
        </div>
        <div
          v-if="isShowSource"
          class="search-input"
        >
          <el-input
            v-model="source"
            @keyup.enter.native="search"
            placeholder="请输入信源名称查询"
          />
          <i
            v-if="isDirectSearch"
            class="icon yq-datatype-mulit"
          />
        </div>
        <treeSelect
          v-if="isShowDepartment"
          ref="treeSelectDepart"
          placeholder="所属机构"
          label-name=""
          :tree-option="{
            multiple: true,
            flat: isDepartmentFlat,
            clearable: false
          }"
          :tree-list="departmenList"
          :format-option="formatDepartment"
          @changeSelected="changeSelected"
        />
        <el-button
          v-if="!isDirectSearch"
          @click="handleSearch"
        >
          查询
        </el-button>
      </div>
      <dialogExport
        v-show="listData.length!==0"
        :is-diolog-append-body="true"
        :total="total"
        export-file-name="审读报告-稿件列表-导出表格"
        :download-params="downloadParams"
        :download-url="downloadUrl"
      />
    </div>
    <detailTable
      :thead="realThead"
      :tpropty="realTpropty"
      :table-data="listData"
      :is-show-btns="true"
      @handleRowClick="handleRowClick"
    />
    <Cypagination
      ref="cypagination"
      :total="total"
      :pagesize="pagesize"
      @handleCurrentChange="handleCurrentChange"
    />
  </dialogCommon>
</template>

<script>
import dialogCommon from '@components/dialog/cyDialogCommon'
import treeSelect from '@views/jlxk/review/components/treeSelect'
import detailTable from '@components/jgsd/table'
import dialogExport from '@components/dialog/dialogExport'
import APIS from '@apis/jlxk.js'
import { toTopAnimation } from '@common/util.js'
import { inspectTypeArr } from '../data/type.js'
export default {
  name: 'DetailDialog',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    baseParams: {
      type: Object,
      default: () => {}
    },
    articleType: {
      type: Object,
      default: () => {}
    },
    folderType: {
      type: Object,
      default: () => {}
    },
    isShowDepartment: {
      type: Boolean,
      default: true
    },
    apis: {
      type: String,
      default: 'postSpcialSearch'
    },
    isShowInspectType: {
      type: Boolean,
      default: false
    },
    // 每项变动直接查询为true，否则就是变更后点击查询按钮才进行查询
    isDirectSearch: {
      type: Boolean,
      default: false
    },
    isShowSource: {
      type: Boolean,
      default: false
    },
    thead: {
      type: Array,
      default: () => [
        '标题',
        { label: '稿件类型', width: 90 },
        { label: '时间', width: 150 },
        '媒体名称',
        { label: '所属机构', width: 150 },
        { label: '审读状态', width: 90 },
        { label: '操作', width: 120 }
      ]
    },
    tpropty: {
      type: Array,
      default: () => [
        'title',
        'type',
        'pubdate',
        'source',
        'department',
        'status',
        'btns'
      ]
    },
    downloadUrl: {
      type: String,
      default: '/mbd-special/shendu/statistics/export'
    }
  },
  components: {
    dialogCommon,
    detailTable,
    treeSelect,
    dialogExport
  },
  data() {
    return {
      inspectType: '审校类型',
      inspectTypeList: ['审校类型', ...inspectTypeArr.map(item => item.name)],
      keyword: '',
      departmenList: [],
      checkedDepartment: [],
      source: '',
      total: 0,
      page: 1,
      pagesize: 20,
      listData: [],
      noChannelArr: ['wechat', 'weibo'],
      channelArr: ['news', 'app', 'epaper'],
      imgText: ['1', '4']
    }
  },
  computed: {
    realThead() {
      if (!String(this.baseParams.system) || String(this.baseParams.system) !== '0') return this.thead
      return this.thead.filter(item => item !== '媒体名称')
    },
    realTpropty() {
      if (!String(this.baseParams.system) || String(this.baseParams.system) !== '0') return this.tpropty
      return this.tpropty.filter(item => item !== 'source')
    },
    getParams() {
      return Object.assign({}, this.baseParams, {
        page: this.page,
        pagesize: this.pagesize,
        title: this.keyword,
        departmentIds: this.departmentIds,
        beginPubDate: this.baseParams.beginTime,
        endPubDate: this.baseParams.endTime,
        source: this.isShowSource ? this.source : undefined,
        showContent: 0,
        sortField: 'pubdate',
        beginTime: undefined,
        endTime: undefined,
        reviewType: this.isShowInspectType
          ? this.inspectType === '审校类型'
            ? ''
            : this.inspectType
          : undefined
      })
    },
    downloadParams() {
      return Object.assign({}, this.getParams, {
        page: undefined,
        pagesize: undefined,
        showContent: undefined
      })
    },
    isDepartmentFlat() {
      try {
        return !xk_department_tree_cascade
      } catch (error) {
        return true
      }
    },
    totalFolderType() {
      return Object.assign({}, this.folderType, {
        douyin: '短视频',
        kuaishou: '短视频',
        miaopai: '短视频',
        bilibili: '短视频'
      })
    },
    departmentIds() {
      if (this.checkedDepartment.length === 0) return ''
      if (this.isDepartmentFlat) {
        return this.checkedDepartment.map(item => item.id).join(',')
      }
      let result = []
      // 待优化
      this.checkedDepartment.forEach(item => {
        result.push(item.id)
        if (item.child && item.child.length !== 0) {
          item.child.forEach(subItem => {
            result.push(subItem.id)
            if (subItem.child && subItem.child.length !== 0) {
              subItem.child.forEach(thirdItem => {
                result.push(thirdItem.id)
                if (thirdItem.child && thirdItem.child.length !== 0) {
                  thirdItem.child.forEach(fourItem => {
                    result.push(fourItem.id)
                    if (fourItem.child && fourItem.child.length !== 0) {
                      fourItem.child.forEach(fiveItem => {
                        result.push(fiveItem.id)
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
      return result.join(',')
    },
    currentIndex() {
      return this.$store.state.currentIndex
    }
  },
  created() {},
  mounted() {
    if (this.isShowDepartment) {
      this.getCatDepartment()
    }
  },
  methods: {
    init(val) {
      this.keyword = ''
      this.page = 1
      this.source = ''
      this.inspectType = (val && val.inspectType) || '审校类型'
      if (this.$refs.treeSelectDepart && this.isShowDepartment) {
        this.$refs.treeSelectDepart.checkedTreeList = val ? [val] : []
      }
      this.checkedDepartment = val ? [val] : []
      this.$nextTick(() => {
        this.$refs.cypagination.page = 1
      })
      this.getSpcialQuery()
    },
    // 获取机构列表
    async getCatDepartment() {
      let { status, data } = await APIS.postDepartmentTree()
      if (status === 0 && data && data.length !== 0) {
        this.departmenList = data
      } else {
        this.departmenList = []
      }
    },
    async getSpcialQuery() {
      let { status, data } = await APIS[this.apis]({
        data: this.getParams
      })
      if (status === 0 && data && data.result && data.result.length !== 0) {
        this.total = data.total
        this.listData = data.result.map(item => {
          let isInterNet = String(item.oriSystem) === '1'
          return {
            id: item.id,
            title:
              isInterNet && item.folder === 'weibo'
                ? item.title || item.description
                : item.title,
            system: item.oriSystem,
            type: isInterNet
              ? this.totalFolderType[item.folder]
              : this.articleType[item.articleTypeId],
            pubdate: item.pubdate,
            source: !isInterNet
              ? '-'
              : this.noChannelArr.indexOf(item.folder) !== -1
                ? item.channel
                : this.channelArr.indexOf(item.folder) !== -1
                  ? item.source
                  : item.folder === 'wemedia'
                    ? `${item.source}（${item.channel}）`
                    : `${item.channel}（${item.source}）`,
            department: item.department,
            status:
              String(item.oristatus) === '6'
                ? '不通过'
                : String(item.oristatus) === '5'
                  ? '通过'
                  : '提交待审',
            isBtnCount:
              isInterNet ||
              (!isInterNet && this.imgText.indexOf(item.oristatus) !== -1),
            location: item.location,
            suspiciousCount: item.suspiciousCount || 0
          }
        })
        if (document.querySelector('.detailDialog .el-table__body-wrapper')) {
          toTopAnimation('.detailDialog .el-table__body-wrapper')
        }
      } else {
        this.listData = []
        this.total = 0
      }
    },
    // 格式tree数据
    formatDepartment(node) {
      if (node.child && !node.child.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.name,
        children: node.child
      }
    },
    changeSelected(val) {
      this.checkedDepartment = [...val]
    },
    handleRowClick(value) {
      if (value.prop !== 'btns' || !value.isBtnCount) return false
      let url = this.$router.resolve({
        path: '/jgsd/review/report/article',
        query: { modelId: this.currentIndex, id: value.id }
      })
      window.open(url.href, '_blank')
    },
    handleSearch() {
      this.page = 1
      this.$refs.cypagination.page = 1
      this.getSpcialQuery()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getSpcialQuery()
    },
    search() {
      if (!this.isDirectSearch) return false
      this.handleSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.detailDialog {
  /deep/ .el-dialog {
    &__header {
      padding-bottom: 20px;
    }
    &__body {
      .el-table {
        &__body-wrapper {
          max-height: calc(100vh - 300px);
          overflow-y: auto;
        }
      }
      .condition {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .el-select {
          margin-right: 10px;
        }
        .el-button {
          width: 86px;
          height: 30px;
          padding: 0;
          line-height: 30px;
          background: #4497ec;
          border-radius: 5px;
          font-size: 13px;
          font-family: "founder_youhei_508R";
          color: #fff;
        }
        &_input {
          display: flex;
          .search-input {
            position: relative;
            i {
              position: absolute;
              right: 9px;
              top: 8px;
            }
            &.keyword {
              margin-right: 10px;
            }
          }
          .el-input {
            &__inner {
              width: 200px;
              background: #fff;
              font-family: "founder_youhei_508R";
              border-radius: 5px;
            }
          }
          .tree-box {
            margin-right: 10px;
            .filter_item-label {
              display: none;
            }
          }
          .el-button {
            width: 60px;
          }
        }
      }
      .vue-treeselect {
        left: 0;
      }
      .el-pagination {
        padding-bottom: 0;
      }
    }
  }
}
</style>
